// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"142":"78cd6467","340":"aa6be377"}[chunkId] + ".css";
};